var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 5.99992C8.49992 5.72378 8.27606 5.49992 7.99992 5.49992C7.72378 5.49992 7.49992 5.72378 7.49992 5.99992V7.49992H5.99992C5.72378 7.49992 5.49992 7.72378 5.49992 7.99992C5.49992 8.27606 5.72378 8.49992 5.99992 8.49992H7.49992V9.99992C7.49992 10.2761 7.72378 10.4999 7.99992 10.4999C8.27606 10.4999 8.49992 10.2761 8.49992 9.99992V8.49992H9.99992C10.2761 8.49992 10.4999 8.27606 10.4999 7.99992C10.4999 7.72378 10.2761 7.49992 9.99992 7.49992H8.49992V5.99992Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 0.833252C4.04188 0.833252 0.833252 4.04188 0.833252 7.99992C0.833252 11.958 4.04188 15.1666 7.99992 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99992 0.833252ZM1.83325 7.99992C1.83325 4.59416 4.59416 1.83325 7.99992 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99992 14.1666C4.59416 14.1666 1.83325 11.4057 1.83325 7.99992Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle-plus.861f044da5603ea9f84fd3f0421912e4.svg";
export { ForwardRef as ReactComponent };